import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const DISTRICTBOUNDARIES_LAYER_ID = 'DistrictBoundariesLayer';

const layerConfig = {
  title: 'District Boundaries',
};

function DistrictBoundariesLayer() {
  const dispatch = useDispatch();
  const { DistrictBoundariesLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, DistrictBoundariesLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
   const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 5 : 2;

  if (DistrictBoundariesLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: DISTRICTBOUNDARIES_LAYER_ID,
      geoColumn: 'geom',
      stroked: true,
      filled: true,
      lineWidthMinPixels: pointLineWidth,
      getLineColor: [0, 0, 0, 255], 
      getFillColor: [0, 0, 0, 0],  
    
      coverage: 0.95,
      pickable: true,
      visible: DistrictBoundariesLayer.visible,
      opacity: DistrictBoundariesLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: DISTRICTBOUNDARIES_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
              if (info?.object) {
                info.object = {
                  html: htmlForFeature({
                    feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default DistrictBoundariesLayer;
